import {isEmpty} from 'cl-form/validation/validators';
import * as React from 'react';
import * as _ from 'lodash';
import {getFormValues} from 'redux-form';
import {unflatten} from 'flat';
import DeleteIcon from '@material-ui/icons/Delete';
import PublishIcon from '@material-ui/icons/Publish';
import CachedIcon from 'material-ui/svg-icons/action/cached';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import RefreshIcon from '@material-ui/icons/Refresh';
import {EBAY_LISTINGS_ACTIONS_TYPES} from '../ActionsTypes';
import {ACTION_DISPLAY_TYPES, ActionProps, BaseActionsProps} from '../ActionsManagerConsts';
import {REVISE_STATUS} from '../../globalConsts';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';

import {
  createNewListings,
  duplicateListings,
  duplicateListingsAndEdit,
  getEbayListingsIds,
  getEbayListingsSellerId,
  isActiveListing,
  isDraftListing,
  isEndedListing,
  isReviseStatusError,
  isScheduledListing,
  openDuplicateListingDialog,
  openEditDescriptionAction,
  openEndListingDialog,
  openPickATemplatePopover,
  retryListings,
  saveDraft,
  savePublishToEbayMapping,
  showRemoveTemplateDialog,
  updateEbayListingData,
  updateListings,
  updateListingsTableAndRecentCategories,
} from './EbayListingsActionsHelpers';
import {
  getEditVariationsDialogStoreProps,
  getIsDirtyStoreProps,
  getReduxTableStoreProps,
  hasVariationsStoreProps,
  hasVariationsToAddDialogStoreProps,
} from './EbayListingsActionsSelectors';
import {scrollToTopMostFieldWithError} from '../../../MyAccount/Listings/EbayListing/ListerField/scrollToFieldUtils';
import routes, {MyAccount} from '../../../App/routeConstants';
import {EbayListing, EbayListingModel, ListingsApiRequestOptions, SkuToProductMappingKeys, Tables} from 'cl-api';
import {
  fixItemSpecificsWithDots,
  getErrorTexts,
  getFieldsToRevise,
  getItemSpecificFieldName,
  getProductData,
  getSellerId,
  getUpdatedEbayListingValues,
  getUpdatedEbayListingValuesForSave,
  getUpdatedFieldValue,
  getUpdatedVariations,
  getUpdatedVariationsData,
  getUpdatedVariationsPictureNode,
  getVariationAspectNames,
  getVariationSpecificNames,
  getVariationSpecificsSet,
  isNonDraftItemId,
  getVariationProductListingDetailsType,
} from '../../../MyAccount/Listings/EbayListing/ebayListingSelectors';
import {clearReviseError, refreshFromEbay, showDeleteDraftsDialog} from '../../../MyAccount/Listings/listingsHelper';
import {
  DELETE_ALL_VARIATIONS_LIVE_LISTING,
  EPID_DISABLED_BY_VARIATIONS,
  FIELD_NAMES,
  getItemSpecificWithoutPrefix,
  USE_DEFAULT_PHOTOS,
  VARIATION_PRODUCT_LISTING_DETAILS,
  VARIATIONS_ROOT,
  VARIATIONS_SELECTED_ASPECT,
} from '../../../MyAccount/Listings/EbayListing/consts';
import {store} from '../../../App/store';
import {doNotDisturb, duplicate, fileHidden} from 'cl-icons';
import {
  resetFieldsToRevise,
  setSaveAndUpdateClicked,
  updateFieldToRevise,
  updateMultipleFieldsToRevise,
} from '../../../MyAccount/ViewDesigns/redux/modules/ebayListing';
import {browserHistory} from 'react-router';
import CustomSvgIconTS from '../../../crazyEditor/components/EditorUI/BaseUI/CustomSvgIcon/CustomSvgIconTS';
import {
  getNonChildrenCount,
  getNonChildrenValidDataCount,
  getUpdatedData,
  getValidData,
  removeDisabledFieldsFromData,
} from 'cl-table/redux/selectors';
import {PublishConfirmationDialogFormData} from '../../components/Dialogs/PublishToEbayConfirmationDialog/PublishToEbayConfirmationDialog';
import {ColumnsType, deleteTable, removeMetadataFields} from 'cl-table/redux/actions';
import {setPublishInProgress} from '../../../MyAccount/ViewDesigns/redux/modules/listingsPage';
import {deleteVariation, isDraftItemId} from '../../helpers/EbayListingsGeneralHelpers';
import {RadioBoolean} from 'cl-form/FormRadio';
import {addDynamicDialog} from '../../../crazyEditor/redux/modules/panel/panel';
import {VARIATIONS_TABLE} from '../../../MyAccount/Listings/EbayListing/VariationsSection';
import {fromJS} from 'immutable';
import {extractObjectData} from 'cl-form/utils/objectFormUtils';
import {getCurrentState} from './currentState';
import update from 'immutability-helper';
import ListerVariationOptionsDialog from '../../../MyAccount/Listings/EbayListing/ListerVariationOptionsDialog';
import ListerAddVariationDialog from '../../../MyAccount/Listings/EbayListing/ListerAddVariationDialog';
import {
  adjustVariationsTableSelection,
  convertSelectionToIDs,
  createSingleVariationsByFormValues,
  generateNewVariations,
  unflattenNestedVariationsSpecificsIfExist,
} from '../VariationsActions/VariationsActionsHelpers';
import {getVariationSpecificsSetByVariations} from '../../../MyAccount/Inventory/EditProductSelectors';
import {isChildRow, isParentRow, getChildrenRows} from 'cl-table/VirtualizedHelpers';

export interface EbayListingsActionsProps extends BaseActionsProps {
  types: Array<EBAY_LISTINGS_ACTIONS_TYPES>;
  listingsIds: string[];
}

const removeTemplateShouldRender = ({statusFilter, templateId, templateName}) =>
  (isActiveListing(statusFilter) || isScheduledListing(statusFilter)) &&
  !!(templateId || templateName !== 'No Template');
export const EBAY_LISTINGS_ACTIONS_PROPS: {[actionType: string]: ActionProps<EbayListing>} = {
  [EBAY_LISTINGS_ACTIONS_TYPES.RETRY]: {
    shouldRender: ({statusFilter, reviseStatus, lastFailedTemplateId}) =>
      isReviseStatusError(reviseStatus) && !isEndedListing(statusFilter) && !!lastFailedTemplateId,
    action: objects => {
      return () => {
        const sellerId = getEbayListingsSellerId(objects);
        return retryListings(objects, sellerId);
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.MENU_ITEM]: {label: 'Retry Update'},
    },
  },
  [EBAY_LISTINGS_ACTIONS_TYPES.CANCEL]: {
    shouldRender: ({statusFilter, reviseStatus}) => isReviseStatusError(reviseStatus) && !isEndedListing(statusFilter),
    action: objects => {
      return () => clearReviseError(getEbayListingsIds(objects));
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.MENU_ITEM]: {label: 'Cancel Update'},
    },
  },
  [EBAY_LISTINGS_ACTIONS_TYPES.SHOW_DESCRIPTION]: {
    shouldRender: ({statusFilter}) => isEndedListing(statusFilter),
    action: openEditDescriptionAction,
    singleObjectOnly: true,
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.MENU_ITEM]: {label: 'Show Description'},
    },
  },
  [EBAY_LISTINGS_ACTIONS_TYPES.EDIT_DESCRIPTION]: {
    shouldRender: ({statusFilter}) => isActiveListing(statusFilter) || isScheduledListing(statusFilter),
    action: openEditDescriptionAction,
    singleObjectOnly: true,
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.MENU_ITEM]: {label: 'Edit Description'},
    },
  },
  [EBAY_LISTINGS_ACTIONS_TYPES.DELETE]: {
    shouldRender: ({statusFilter}) => isDraftListing(statusFilter),
    action: objects => {
      return () => showDeleteDraftsDialog(getEbayListingsSellerId(objects), getEbayListingsIds(objects));
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'DELETE', icon: <DeleteIcon />, color: 'error'},
      [ACTION_DISPLAY_TYPES.MENU_ITEM]: {label: 'Delete', leftIcon: <DeleteIcon />},
    },
  },
  [EBAY_LISTINGS_ACTIONS_TYPES.REMOVE_TEMPLATE]: {
    shouldRender: removeTemplateShouldRender,
    action: objects => {
      return () => showRemoveTemplateDialog(getEbayListingsSellerId(objects), getEbayListingsIds(objects));
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.SPLIT_BUTTON]: {label: 'REMOVE TEMPLATE', color: 'error', variant: 'text'},
      [ACTION_DISPLAY_TYPES.MENU_ITEM]: {label: 'Remove template'},
    },
  },
  [EBAY_LISTINGS_ACTIONS_TYPES.RESTORE_ORIGINAL_DESIGN]: {
    shouldRender: removeTemplateShouldRender,
    action: objects => {
      return () => showRemoveTemplateDialog(getEbayListingsSellerId(objects), getEbayListingsIds(objects), true);
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.MENU_ITEM]: {label: 'Restore original (Pre-CrazyLister) design'},
    },
  },
  [EBAY_LISTINGS_ACTIONS_TYPES.SAVE_AND_REVISE]: {
    getStoreProps: getIsDirtyStoreProps,
    shouldRender: ({itemID}) => isNonDraftItemId(itemID),
    action: objects => {
      return () => {
        const sellerId = getEbayListingsSellerId(objects);
        const itemId = getEbayListingsIds(objects)[0];
        const state = getCurrentState();
        if (_.isEmpty(getErrorTexts(state))) {
          (window as any).analytics.track('Revise Listing', {'Item ID': itemId});
          const fieldsToRevise = state.ebayListing.fieldsToRevise;
          const unflattenFieldsToRevise = unflatten(fieldsToRevise);
          if (_.get(unflattenFieldsToRevise, FIELD_NAMES.VARIATIONS)) {
            _.set(unflattenFieldsToRevise, FIELD_NAMES.VARIATIONS, fieldsToRevise[FIELD_NAMES.VARIATIONS]);
          }
          if (_.get(unflattenFieldsToRevise, FIELD_NAMES.VARIATIONS_PICTURES)) {
            _.set(
              unflattenFieldsToRevise,
              FIELD_NAMES.VARIATIONS_PICTURES,
              fieldsToRevise[FIELD_NAMES.VARIATIONS_PICTURES]
            );
          }
          const listings: EbayListingModel[] = [
            {
              ...fixItemSpecificsWithDots(unflattenFieldsToRevise),
              fieldsToDelete: state.ebayListing.fieldsToDelete,
            },
          ];
          if (!listings[0].clData) {
            listings[0].clData = {};
          }
          listings[0].clData.itemID = objects[0].itemID;
          const allowRetry = state.routing.location.pathname !== MyAccount.EbayListing;
          return updateListings(sellerId, listings, undefined, {allowRetry})
            .then(response => {
              updateEbayListingData(response);
            })
            .catch(() => {
              updateListingsTableAndRecentCategories([itemId]);
            });
        } else {
          store.dispatch(setSaveAndUpdateClicked(true));
          scrollToTopMostFieldWithError();
        }
      };
    },
    isDisabled: (objects, {dirty}) => !dirty,
    singleObjectOnly: true,
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.RAISED_BUTTON]: {label: 'SAVE & REVISE', icon: <PublishIcon />, color: 'primary'},
    },
  },
  [EBAY_LISTINGS_ACTIONS_TYPES.APPLY_TEMPLATE]: {
    shouldRender: _.constant(true),
    action: objects => {
      const sellerId = getEbayListingsSellerId(objects);
      const listings = _.map(objects, object => {
        return {clData: {itemID: object.itemID}};
      });
      return () => {
        const baseListing: EbayListingModel = {
          clData: getFormValues(EBAY_LISTINGS_ACTIONS_TYPES.PICK_TEMPLATE_TO_APPLY)(getCurrentState()) as EbayListing,
        };
        (window as any).analytics.track('Bulk - Update Listings on eBay', {
          'Number of Listings': objects.length,
          'Seller ID': sellerId,
        });
        return updateListings(sellerId, listings, baseListing);
      };
    },
    verifyUser: true,
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.RAISED_BUTTON]: {label: 'APPLY TEMPLATE', color: 'primary'},
    },
  },
  [EBAY_LISTINGS_ACTIONS_TYPES.PICK_TEMPLATE_TO_APPLY]: {
    shouldRender: ({statusFilter}) => isActiveListing(statusFilter) || isScheduledListing(statusFilter),
    action: (objects, ref) => {
      return () => {
        openPickATemplatePopover(objects, ref);
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.RAISED_BUTTON]: {
        label: 'PICK A TEMPLATE',
        color: 'primary',
        icon: <ArrowDropDownIcon />,
        IconAfterLabel: true,
      },
    },
  },
  [EBAY_LISTINGS_ACTIONS_TYPES.OPEN_DUPLICATE_LISTINGS_DIALOG]: {
    getStoreProps: getIsDirtyStoreProps,
    shouldRender: _.constant(true),
    isDisabled: (object, {dirty}) => _.isEmpty(object) || dirty,
    action: objects => {
      return () => {
        openDuplicateListingDialog(objects);
      };
    },
    getTooltip: (objects, {dirty}) => (dirty ? 'Listings with unsaved changes cannot be duplicated' : undefined),
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'DUPLICATE', icon: <CustomSvgIconTS path={duplicate} />},
      [ACTION_DISPLAY_TYPES.MENU_ITEM]: {label: 'Duplicate'},
    },
    objectIsOptional: true,
  },
  [EBAY_LISTINGS_ACTIONS_TYPES.DUPLICATE_LISTINGS]: {
    shouldRender: _.constant(true),
    action: objects => {
      return () => {
        return duplicateListings(objects);
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'DUPLICATE'},
    },
  },
  [EBAY_LISTINGS_ACTIONS_TYPES.DUPLICATE_LISTING_AND_EDIT]: {
    shouldRender: _.constant(true),
    action: objects => {
      return () => {
        return duplicateListingsAndEdit(objects);
      };
    },
    singleObjectOnly: true,
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'DUPLICATE & EDIT'},
    },
  },
  [EBAY_LISTINGS_ACTIONS_TYPES.OPEN_END_LISTINGS_DIALOG]: {
    shouldRender: ({statusFilter}) => isActiveListing(statusFilter),
    action: objects => {
      return () => {
        openEndListingDialog(getEbayListingsIds(objects));
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'END', icon: <CustomSvgIconTS path={doNotDisturb} />},
      [ACTION_DISPLAY_TYPES.MENU_ITEM]: {label: 'End'},
    },
  },
  [EBAY_LISTINGS_ACTIONS_TYPES.END_LISTINGS]: {
    shouldRender: _.constant(true),
    action: objects => {
      const sellerId: string = getEbayListingsSellerId(objects);
      const listings: EbayListingModel[] = _.map(objects, object => {
        return {clData: {itemID: object.itemID}};
      });
      const baseListing: EbayListingModel = {clData: {statusFilter: EbayListing.StatusFilterEnum.Ended}};
      return () => {
        const state = getCurrentState();
        const endListingFormValues = getFormValues(EBAY_LISTINGS_ACTIONS_TYPES.END_LISTINGS)(state) as any;
        const endingReason: ListingsApiRequestOptions.EndingReasonEnum =
          endListingFormValues && endListingFormValues.endingReason ? endListingFormValues.endingReason : null;
        return updateListings(sellerId, listings, baseListing, {allowRetry: false, endingReason});
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'YES, END THESE LISTINGS'},
    },
  },
  [EBAY_LISTINGS_ACTIONS_TYPES.SAVE_DRAFT]: {
    getStoreProps: getIsDirtyStoreProps,
    shouldRender: object => isDraftItemId(object.itemID),
    action: objects => {
      return () => {
        const state = getCurrentState();
        const sellerId = getSellerId(state);
        const listing: EbayListingModel = getUpdatedEbayListingValuesForSave(state);
        const allowRetry = state.routing.location.pathname !== MyAccount.EbayListing;
        const itemId = getEbayListingsIds(objects)[0];
        const baseListing: EbayListingModel = {clData: {statusFilter: EbayListing.StatusFilterEnum.Draft}};
        if (itemId) {
          return saveDraft(sellerId, [listing], baseListing, {allowRetry}).then(response => {
            updateEbayListingData(response);
          });
        } else {
          return createNewListings({objects: [listing], baseObject: baseListing, options: {allowRetry}}, sellerId).then(
            response => {
              updateEbayListingData(response, true);
            }
          );
        }
      };
    },
    isDisabled: (objects, {dirty}) =>
      !!(!dirty || (objects[0] && objects[0].reviseStatus === REVISE_STATUS.PROCESSING)),
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'SAVE DRAFT', icon: <CustomSvgIconTS path={fileHidden} />},
    },
    objectIsOptional: true,
  },
  [EBAY_LISTINGS_ACTIONS_TYPES.SAVE_AND_PUBLISH]: {
    getStoreProps: getIsDirtyStoreProps,
    shouldRender: object => isDraftItemId(object.itemID),
    action: objects => {
      return () => {
        const state = getCurrentState();
        const sellerId = getSellerId(state);
        const itemId = getEbayListingsIds(objects)[0];
        const valid = _.isEmpty(getErrorTexts(state));
        const listing: EbayListingModel = getUpdatedEbayListingValuesForSave(state);
        listing.clData = _.omit(listing.clData, 'statusFilter');
        const baseListing: EbayListingModel = {clData: {statusFilter: EbayListing.StatusFilterEnum.Active}};
        if (valid) {
          return createNewListings(
            {objects: [listing], baseObject: baseListing, options: {allowRetry: false}},
            sellerId,
            itemId
          ).then(response => {
            updateEbayListingData(response, true);
          });
        } else {
          store.dispatch(setSaveAndUpdateClicked(true));
          scrollToTopMostFieldWithError();
        }
      };
    },
    isDisabled: (objects, {dirty, nonDraft}) => !dirty && nonDraft,
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.RAISED_BUTTON]: {label: 'Save & Publish', icon: <PublishIcon />, color: 'primary'},
    },
    objectIsOptional: true,
  },
  [EBAY_LISTINGS_ACTIONS_TYPES.REFRESH_LISTING_FROM_EBAY]: {
    shouldRender: _.constant(true),
    action: objects => {
      return () => {
        const state = getCurrentState();
        const sellerId = getSellerId(state);
        const itemId = getEbayListingsIds(objects)[0];
        const site = _.get(getUpdatedEbayListingValues(state), FIELD_NAMES.EBAY_SITE);
        return refreshFromEbay(itemId, sellerId, site);
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'Sync From eBay', icon: <CachedIcon />},
    },
    objectIsOptional: true,
  },
  [EBAY_LISTINGS_ACTIONS_TYPES.RESET_CHANGES]: {
    shouldRender: _.constant(true),
    getStoreProps: getIsDirtyStoreProps,
    action: () => {
      return () => {
        if (!_.isEmpty(_.get(getFieldsToRevise(getCurrentState()), FIELD_NAMES.VARIATIONS))) {
          adjustVariationsTableSelection({});
        }
        store.dispatch(resetFieldsToRevise());
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'Reset Changes', icon: <RefreshIcon />},
    },
    objectIsOptional: true,
    isDisabled: (objects, {dirty}) => !dirty,
  },
  [EBAY_LISTINGS_ACTIONS_TYPES.PUBLISH_PRODUCTS_TO_EBAY]: {
    shouldRender: _.constant(true),
    action: () => {
      return async () => {
        const state = getCurrentState();
        const createDraftIfNotReady =
          (getFormValues(EBAY_LISTINGS_ACTIONS_TYPES.PUBLISH_PRODUCTS_TO_EBAY)(
            state
          ) as PublishConfirmationDialogFormData).createDraftIfNotReady === RadioBoolean.true;
        const sellerId = getSellerId(state);
        const tableState = state.table[Tables.PublishToEbayTable as any];
        const site = tableState.initParams.site;
        const allListings = removeDisabledFieldsFromData(tableState.columns, getUpdatedData(tableState));
        const readyListings = removeDisabledFieldsFromData(tableState.columns, getValidData(tableState));
        const readyListingsNonChildrenCount = getNonChildrenValidDataCount(tableState);
        const {
          additionalData,
          initParams: {categoryId},
        } = tableState;
        _.defer(() =>
          window['analytics'].track('Publish to eBay', {
            'Number of Ready Products': readyListingsNonChildrenCount,
            'Number of Not Ready Products': getNonChildrenCount(tableState) - readyListingsNonChildrenCount,
          })
        );
        const listings: EbayListingModel[] = [];
        (createDraftIfNotReady ? allListings : readyListings).forEach((fieldsToRevise: any) => {
          const listing: EbayListingModel = fixItemSpecificsWithDots(
            unflatten(
              _.pickBy(fieldsToRevise, (value, index) => index !== '_source' && index !== '_id' && !isEmpty(value))
            )
          );
          if (!isChildRow(listing)) {
            if (isParentRow(listing)) {
              const variations = [];
              _.forEach(getChildrenRows(listing, allListings), childListing => {
                const variationProductListingDetails = _.pick(
                  childListing,
                  getVariationProductListingDetailsType(state)
                );

                let variationSpecifics = {};
                _.forEach(_.pick(childListing, getVariationSpecificNames(state)), (aspectValue, aspectName) => {
                  if (!isEmpty(aspectValue)) {
                    variationSpecifics[getItemSpecificWithoutPrefix(aspectName)] = aspectValue;
                  }
                });
                variations.push({
                  ..._.pick(childListing, [FIELD_NAMES.SKU, FIELD_NAMES.QUANTITY, FIELD_NAMES.START_PRICE]),
                  ...(!_.isEmpty(variationProductListingDetails) && {
                    [VARIATION_PRODUCT_LISTING_DETAILS]: variationProductListingDetails,
                  }),
                  VariationSpecifics: variationSpecifics,
                });
                if (childListing[FIELD_NAMES.SKU]) {
                  if (!listing.skuToProductMapping) {
                    listing.skuToProductMapping = {
                      [SkuToProductMappingKeys.VariationsListings]: {},
                    };
                  }
                  listing.skuToProductMapping[SkuToProductMappingKeys.VariationsListings][
                    childListing[FIELD_NAMES.SKU]
                  ] = childListing['_source']._id;
                }
              });
              if (!_.isEmpty(variations)) {
                listing[VARIATIONS_ROOT] = {};
                _.set(listing, FIELD_NAMES.VARIATIONS, variations);
                _.set(listing, FIELD_NAMES.VARIATIONS_SPECIFIC_SET, getVariationSpecificsSetByVariations(variations));
              }
            } else {
              listing.skuToProductMapping = {
                [SkuToProductMappingKeys.RegularListing]: fieldsToRevise._source._id,
              };
            }
            listings.push(removeMetadataFields(listing));
          }
        });

        store.dispatch(deleteTable({name: Tables.PublishToEbayTable as any}));
        browserHistory.push({pathname: routes.MyAccount.Listings, query: {selectedSellerId: sellerId}});
        store.dispatch(setPublishInProgress(true));
        const savePromise = savePublishToEbayMapping({categoryId, sellerId, site}, JSON.stringify(additionalData));
        const taskAdditionalData = {
          ...state.routing.location.query,
          initParams: JSON.parse(state.routing.location.query.initParams),
        };
        const createPromise = createNewListings(
          {
            objects: listings,
            options: {
              async: true,
              activityMeta: {
                task: null,
                sourceName: 'Publish to eBay',
                sourceType: 'Publish to eBay',
                additionalData: taskAdditionalData,
              },
            },
          },
          sellerId
        );
        await savePromise;
        return createPromise;
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'publish products', color: 'primary'},
    },
  },
  [EBAY_LISTINGS_ACTIONS_TYPES.REPORT_MISSING_EBAY_PRODUCT]: {
    shouldRender: _.constant(true),
    action: () => {
      return () => {
        const state = getCurrentState();
        const selectedCategory = _.get(state.table[Tables.FindCatalogTable], 'filter.CategoryId', 0);
        window.open('https://www.ebay.com/slr/prd?categoryId=' + selectedCategory, '_blank');
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'report missing product'},
    },
    objectIsOptional: true,
  },
  [EBAY_LISTINGS_ACTIONS_TYPES.CONTINUE_WITHOUT_EBAY_PRODUCT]: {
    shouldRender: _.constant(true),
    action: () => {
      return () => {
        const state = getCurrentState();
        browserHistory.push({pathname: routes.MyAccount.EbayListing, query: state.routing.location.query});
        const categoryId = _.get(getUpdatedEbayListingValues(state), FIELD_NAMES.PRIMARY_CATEGORY);
        const listingTitle = _.get(getUpdatedEbayListingValues(state), FIELD_NAMES.EBAY_TITLE);
        if (_.isEmpty(listingTitle) && _.isEmpty(categoryId)) {
          const updateFieldToReviseActions = [
            {
              fieldNames: [FIELD_NAMES.EBAY_SITE, FIELD_NAMES.CL_SITE],
              fieldValue: state.table[Tables.FindCatalogTable].filter.Site,
            },
            {
              fieldNames: FIELD_NAMES.PRIMARY_CATEGORY,
              fieldValue: state.table[Tables.FindCatalogTable].filter.CategoryId,
            },
            {fieldNames: FIELD_NAMES.EBAY_TITLE, fieldValue: state.table[Tables.FindCatalogTable].filter.Title},
          ];
          store.dispatch(updateMultipleFieldsToRevise(updateFieldToReviseActions));
        }
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'continue without selecting a product', color: 'primary'},
    },
    objectIsOptional: true,
  },
  [EBAY_LISTINGS_ACTIONS_TYPES.FIND_EBAY_PRODUCT]: {
    getStoreProps: hasVariationsStoreProps,
    shouldRender: _.constant(true),
    action: () => {
      return () => {
        const state = getCurrentState();
        browserHistory.push({pathname: routes.MyAccount.FindEbayProduct, query: state.routing.location.query});
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'FIND A PRODUCT', color: 'default'},
    },
    objectIsOptional: true,
    isDisabled: (objects, {hasVariations}) => hasVariations,
    getTooltip: (objects, {hasVariations}) => (hasVariations ? EPID_DISABLED_BY_VARIATIONS : undefined),
  },
  [EBAY_LISTINGS_ACTIONS_TYPES.MORE_DETAILS_EBAY_PRODUCT]: {
    shouldRender: _.constant(true),
    action: () => {
      return () => {
        const state = getCurrentState();
        const productData = getProductData(state);
        window.open(productData.productWebUrl, '_blank');
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'MORE DETAILS', color: 'default'},
    },
    objectIsOptional: true,
  },
  [EBAY_LISTINGS_ACTIONS_TYPES.OPEN_ADD_VARIATION_DIALOG]: {
    getStoreProps: hasVariationsToAddDialogStoreProps,
    shouldRender: _.constant(true),
    action: () => {
      return () => {
        const tableState = getCurrentState().table[VARIATIONS_TABLE];
        const {columns} = tableState;
        store.dispatch(addDynamicDialog(ListerAddVariationDialog, {columns} as ColumnsType));
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {
        label: 'ADD VARIATION',
        color: 'default',
        icon: <AddIcon />,
      },
    },
    objectIsOptional: true,
    isDisabled: (objects, {hasVariationsToAdd}) => !hasVariationsToAdd,
  },
  [EBAY_LISTINGS_ACTIONS_TYPES.OPEN_EDIT_VARIATION_OPTIONS_DIALOG]: {
    shouldRender: _.constant(true),
    action: () => {
      return () => {
        store.dispatch(addDynamicDialog(ListerVariationOptionsDialog));
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'EDIT VARIATION OPTIONS', color: 'default', icon: <EditIcon />},
    },
    objectIsOptional: true,
  },
  [EBAY_LISTINGS_ACTIONS_TYPES.ADD_SINGLE_VARIATION]: {
    shouldRender: _.constant(true),
    action: () => {
      return () => {
        const state = getCurrentState();
        const formValues = getFormValues(EBAY_LISTINGS_ACTIONS_TYPES.ADD_SINGLE_VARIATION)(state);
        const newVariation = createSingleVariationsByFormValues(formValues, getVariationAspectNames(state));
        store.dispatch(
          updateFieldToRevise(FIELD_NAMES.VARIATIONS, {
            ..._.get(getFieldsToRevise(state), FIELD_NAMES.VARIATIONS),
            ...newVariation,
          })
        );
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'apply', color: 'primary'},
    },
    objectIsOptional: true,
  },
  [EBAY_LISTINGS_ACTIONS_TYPES.EDIT_VARIATION_OPTIONS]: {
    shouldRender: _.constant(true),
    action: () => {
      return () => {
        const state = getCurrentState();
        const formValues = extractObjectData(getFormValues(EBAY_LISTINGS_ACTIONS_TYPES.EDIT_VARIATION_OPTIONS)(state));
        const previousVariationsPictures = getUpdatedVariationsPictureNode(state) || {};
        const newVariationsPictures = {};
        const itemSpecificsToDelete = [];
        const newVariations = generateNewVariations(formValues);
        const newVariationSpecificSet = unflattenNestedVariationsSpecificsIfExist(formValues);
        _.forEach(newVariationSpecificSet, (aspectValue, aspectName) => {
          // handle pictures:
          newVariationsPictures[aspectName] = {};
          _.forEach(aspectValue, (specific: string) => {
            const prevData = previousVariationsPictures[aspectName];
            newVariationsPictures[aspectName][specific] = prevData && specific in prevData ? prevData[specific] : [];
          });
          // handle item specifics
          const itemSpecificName = getItemSpecificFieldName(aspectName);
          const itemSpecificValue = getUpdatedFieldValue(state, itemSpecificName);
          if (itemSpecificValue) {
            itemSpecificsToDelete.push({
              fieldNames: itemSpecificName,
              fieldValue: null,
              originalValue: itemSpecificValue,
            });
          }
        });
        const previousVariations = getUpdatedVariations(state);
        _.forEach(newVariations, (newVariation, id) => {
          if (previousVariations[id]) {
            newVariations[id] = fromJS(previousVariations[id]).toJS();
          }
        });
        const ebayListingVariations = _.get(state.ebayListing.listingData, FIELD_NAMES.VARIATIONS); // irrelevant for drafts
        _.forEach(ebayListingVariations, (ebayListingVariation, id) => {
          if (_.isUndefined(newVariations[id])) {
            newVariations[id] = deleteVariation(ebayListingVariation);
          }
        });
        const prevSelectedAspect = previousVariationsPictures[VARIATIONS_SELECTED_ASPECT];
        if (!_.isEmpty(newVariationSpecificSet)) {
          newVariationsPictures[VARIATIONS_SELECTED_ASPECT] =
            prevSelectedAspect && prevSelectedAspect in newVariationsPictures ? prevSelectedAspect : USE_DEFAULT_PHOTOS;
        }
        const updateFieldToReviseActions = _.concat(
          [
            {fieldNames: FIELD_NAMES.VARIATIONS, fieldValue: newVariations},
            {fieldNames: FIELD_NAMES.VARIATIONS_PICTURES, fieldValue: newVariationsPictures},
            {fieldNames: FIELD_NAMES.VARIATIONS_SPECIFIC_SET, fieldValue: newVariationSpecificSet},
          ],
          itemSpecificsToDelete
        );
        store.dispatch(updateMultipleFieldsToRevise(updateFieldToReviseActions));
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'apply', color: 'primary'},
    },
    getStoreProps: getEditVariationsDialogStoreProps,
    isDisabled: (objects, {nonDraft, emptyEditVariationsForm}) => nonDraft && emptyEditVariationsForm,
    objectIsOptional: true,
  },
  [EBAY_LISTINGS_ACTIONS_TYPES.DELETE_VARIATIONS]: {
    action: () => {
      return async () => {
        const state = getCurrentState();
        const rows = getUpdatedVariations(state);
        let idsToDelete = convertSelectionToIDs(state.table[VARIATIONS_TABLE].selection, _.keys(rows));
        const ebayListingVariations = _.get(state.ebayListing.listingData, FIELD_NAMES.VARIATIONS);
        let deletedVariations = {};
        _.forEach(idsToDelete, rowId => {
          if (_.get(ebayListingVariations, rowId)) {
            deletedVariations[rowId] = deleteVariation(rows[rowId]);
          }
        });
        const revisedVariations = _.get(getFieldsToRevise(state), FIELD_NAMES.VARIATIONS) || {};
        const newRevisedVariations = {..._.omit(revisedVariations, idsToDelete), ...deletedVariations};
        const updatedVariations = getUpdatedVariationsData(
          _.get(state.ebayListing.listingData, FIELD_NAMES.VARIATIONS),
          newRevisedVariations
        );
        let currentSpecifics = getVariationSpecificsSet(state);
        let variationsToKeep = {};
        _.forEach(updatedVariations, variation => {
          _.forEach(variation.VariationSpecifics, (variantName, aspectName) => {
            variationsToKeep[aspectName] = variationsToKeep[aspectName] || {};
            variationsToKeep[aspectName][variantName] = true;
          });
        });
        let currentPictures = getUpdatedVariationsPictureNode(state);
        _.forEach(currentSpecifics, (aspectValue, aspectName) => {
          const toKeep = _.keys(variationsToKeep[aspectName]);
          currentPictures = update(currentPictures, {
            [aspectName]: {$set: _.pick(currentPictures[aspectName], toKeep)},
          });
          currentSpecifics = update(currentSpecifics, {[aspectName]: {$set: _.intersection(aspectValue, toKeep)}});
        });
        const updateFieldToReviseActions = [
          {fieldNames: FIELD_NAMES.VARIATIONS, fieldValue: newRevisedVariations},
          {fieldNames: FIELD_NAMES.VARIATIONS_PICTURES, fieldValue: currentPictures},
          {fieldNames: FIELD_NAMES.VARIATIONS_SPECIFIC_SET, fieldValue: currentSpecifics},
        ];
        store.dispatch(updateMultipleFieldsToRevise(updateFieldToReviseActions));
        adjustVariationsTableSelection(updatedVariations);
      };
    },
    getStoreProps: getReduxTableStoreProps,
    isDisabled: (objects, {nonDraft, allVariationsSelected}) => nonDraft && allVariationsSelected,
    getTooltip: (objects, {nonDraft, allVariationsSelected}) =>
      nonDraft && allVariationsSelected ? DELETE_ALL_VARIATIONS_LIVE_LISTING : undefined,
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'delete variations'},
    },
    objectIsOptional: true,
  },
};
